import React, { Component, useRef } from 'react';
import * as FeatherIcon from 'react-feather';
import { useSpring, animated } from 'react-spring';
import { v4 as uuidv4 } from 'uuid';
import logo from 'images/logoNoBackground.png';
import botLogo from 'images/chatLogo.png';
import chatLogo from 'images/logoNoBackground.png';
import './index.css';
import _cloneDeep from 'lodash/cloneDeep';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { getChatBotResponse, giveChatFeedBack } from '../../../service/infinitetableproperties/action';
import RaiseTicket from './RaiseTicket';
import Info from './Info';
import { content } from './Info/constants';
import { FaThumbsUp, FaThumbsDown } from 'react-icons/fa';

const Footer = () => {
    const messagesEndRef = useRef(null);
    const chatBodyRef = useRef(null);

    const [showChat, setShowChat] = React.useState(false);
    const [qus, setQus] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isMaximized, setIsMaximized] = React.useState(false);
    const [chatType, setChatType] = React.useState('');
    const [chatId, setChatId] = React.useState('');
    const defaultMessage = [
        { message: 'Hello User!!', isUser: false },
        { message: 'Hi There!!', isUser: true },
    ];
    const [messages, setMessages] = React.useState([]);
    const chatTypes = (type) => {
        setChatType(type);
        const msg = {
            // id: Date.now(),
            message: type === 'BlocData' ? 'How may I help you?' : 'Click here to enter your issue description',
            isUser: false,
            isRaiseTicket: type !== 'BlocData',
            note: '',
            reason: '',
            feedback: 2,
        };
        setMessages([msg]);
    };
    const chatSpring = useSpring({
        transform: showChat ? 'translateX(0%)' : 'translateX(101%)',
    });

    const formatMessages = () => {
        const memory = [];
        let seq = 1;

        for (let i = 0; i < messages.length; i++) {
            if (messages[i].isUser && messages[i + 1] && !messages[i + 1].isUser) {
                memory.push({
                    USER: messages[i].message,
                    AI: messages[i + 1].message,
                    seq_no: seq++,
                    feedback: messages[i + 1].feedback,
                });
                i++;
            }
        }

        return memory;
    };

    React.useEffect(() => {
        chatTypes('BlocData');
        setChatId('');
    }, []);

    const toggleChat = () => {
        setQus('');
        setShowChat(!showChat);
        if (!showChat) {
            chatTypes('BlocData');
            setChatId(uuidv4());
        } else {
            setChatId('');
        }
    };

    const sendChat = async () => {
        if (chatType === 'BlocData') {
            const request = { id: Date.now(), message: qus, isUser: true };
            setMessages((prev) => [...prev, request]);
            const memory = formatMessages();
            setQus('');
            try {
                const { data } = await getChatBotResponse(qus, memory, chatId);
                const {
                    answer,
                    plan: { note, reason },
                } = data;
                const response = {
                    id: Date.now() + 1,
                    message: typeof answer === 'string' ? answer : JSON.stringify(answer),
                    isUser: false,
                    note: note,
                    reason: reason,
                    feedback: 2,
                };
                setMessages((prev) => [...prev, response]);
            } catch (err) {
                console.error('Error fetching chatbot response', err);
            }
        }
        setLoading(false);
    };

    React.useEffect(() => {
        const container = chatBodyRef.current;
        if (!container) return;

        // Try smooth scroll, fallback to scrollTop
        if (typeof container.scrollTo === 'function') {
            try {
                container.scrollTo({ top: container.scrollHeight, behavior: 'smooth' });
            } catch (e) {
                container.scrollTop = container.scrollHeight;
            }
        } else {
            container.scrollTop = container.scrollHeight;
        }
    }, [messages, showChat]);

    const showDescription = (result) => {
        const answers = [
            {
                id: Date.now(),
                message: `Issue Title: ${result['issue_title']}`,
                isUser: false,
            },
            {
                id: Date.now() + 1,
                message: `Jira ID: ${result['jira_id']}`,
                isUser: false,
            },
            {
                id: Date.now() + 2,
                message: `Email Response: ${result['email_response']}`,
                isUser: false,
            },
        ];
        setMessages((prev) => [...prev, ...answers]);
    };
    const lastMessageId = messages[messages.length - 1]?.id;

    const handleFeedback = async (messageId, type) => {
        setMessages((prev) => prev.map((msg) => (msg.id === messageId ? { ...msg, feedback: type } : msg)));
        const memory = formatMessages();
        const recentMemory = [...memory].sort((a, b) => b.seq_no - a.seq_no);
        const seqNo = recentMemory.length > 0 ? recentMemory[0].seq_no : 0;
        const { data } = await giveChatFeedBack(seqNo, type, chatId);
    };

    return (
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div>
                        {/* <div class="div-img">
                            <img onClick={toggleChat} className="enlarge" src={botLogo} />
                        </div> */}
                        <animated.div
                            className={isMaximized ? 'chat-container-max mb-1 mr-1' : 'chat-container mb-1 mr-1'}
                            style={chatSpring}
                        >
                            <div className="chat-header">
                                <div className="d-flex w-100 ">
                                    <div className="d-flex align-items-center">
                                        <Label clas>Vincilium</Label>
                                        {/* <Info content={content} size={18} isMaximized={isMaximized} /> */}
                                    </div>
                                    {isMaximized ? (
                                        <FeatherIcon.Minimize2
                                            style={{ cursor: 'pointer' }}
                                            className="mt-2 me-3 icon-xs ms-auto"
                                            onClick={() => setIsMaximized(!isMaximized)}
                                        />
                                    ) : (
                                        <FeatherIcon.Maximize2
                                            style={{ cursor: 'pointer' }}
                                            className="mt-2 me-3 icon-xs ms-auto"
                                            onClick={() => setIsMaximized(!isMaximized)}
                                        />
                                    )}
                                    <FeatherIcon.X style={{ cursor: 'pointer' }} className="mt-2 icon-xs " onClick={() => toggleChat()} />
                                </div>
                            </div>
                            <div className="chat-body" ref={chatBodyRef} style={{ height: '85%', overflowX: 'hidden', overflowY: 'auto' }}>
                                {defaultMessage.map((item, idx) => (
                                    <>
                                        <div className={item.isUser ? 'float-end font-weight-bold' : 'float-start w-100'} key={idx}>
                                            {!item.isUser && <img src={chatLogo} height={15} className="me-2 mb-1" alt="" />}
                                            {item.message}
                                        </div>
                                        <br />
                                    </>
                                ))}
                                {/* <FormGroup className="d-flex w-100 m-2">
                                    <div className="mx-3 w-100" style={{ position: 'sticky' }}>
                                        <Input
                                            className="mt-1"
                                            name="chatType"
                                            checked={chatType === 'BlocData'}
                                            onClick={() => chatTypes('BlocData')}
                                            type="radio"
                                        />
                                        <Label>Bloc Data</Label>
                                    </div>
                                    <div className="mx-3 w-100" style={{ position: 'sticky' }}>
                                        <Input className="mt-1" name="chatType" onClick={() => chatTypes('RaiseTicket')} type="radio" />
                                        <Label>Raise Ticket</Label>
                                    </div>
                                </FormGroup> */}
                                {messages.map((data, index) => (
                                    <>
                                        <div
                                            className={data.isUser ? 'float-end my-1 mt-3 font-weight-bold' : 'float-start w-100 my-1'}
                                            key={data.id || index}
                                        >
                                            {!data.isUser && <img src={chatLogo} height={15} className="me-2 mb-0 mt-1" alt="" />}
                                            {/* {data.isRaiseTicket ? (
                                                <a href="javascript:void(0)" onClick={() => setIsModalOpen(!isModalOpen)}>
                                                    {data.message}
                                                </a>
                                            ) : ( */}
                                            <>
                                                {data?.note && (
                                                    <div style={{ marginLeft: 25, marginTop: '-20px' }}>
                                                        <em>{data.note}</em>
                                                    </div>
                                                )}
                                                <div
                                                    style={{ marginLeft: 25, marginTop: data?.note ? '10px' : '-20px' }}
                                                    title={data?.reason}
                                                >
                                                    {data?.message &&
                                                        data?.message?.split('\n').map((itm, idx2) => <div key={idx2}>{itm}</div>)}
                                                </div>
                                                {!data.isUser && data.id > 0 && data.id === lastMessageId && data.feedback === 2 && (
                                                    <div style={{ marginTop: 5 }}>
                                                        <button
                                                            onClick={() => handleFeedback(data.id, 1)}
                                                            style={{
                                                                marginRight: 5,
                                                                color: data.feedback === 1 ? 'green' : 'black',
                                                            }}
                                                        >
                                                            👍
                                                        </button>
                                                        <button
                                                            onClick={() => handleFeedback(data.id, 0)}
                                                            style={{
                                                                color: data.feedback === 0 ? 'red' : 'black',
                                                            }}
                                                        >
                                                            👎
                                                        </button>
                                                    </div>
                                                )}

                                                {data.feedback === 1 && <span style={{ marginLeft: 20 }}>👍</span>}
                                                {data.feedback === 0 && <span style={{ marginLeft: 20 }}>👎</span>}
                                            </>
                                            {/* )} */}
                                        </div>
                                        <br />
                                    </>
                                ))}
                                {/* Scroll target (kept) */}
                                <div ref={messagesEndRef} />
                            </div>
                            <Form>
                                <div className="w-100" style={{ position: 'absolute', bottom: 2, left: 2 }}>
                                    {loading && (
                                        <div class="typing mb-3 ml-2">
                                            <span className="typingDot"></span>
                                            <span className="typingDot"></span>
                                            <span className="typingDot"></span>
                                        </div>
                                    )}
                                    <div className="d-flex w-100">
                                        <Input
                                            placeholder="How can I help you ?"
                                            value={qus}
                                            type="text"
                                            onChange={({ target: { value } }) => setQus(value)}
                                        />
                                        <button
                                            type="submit"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLoading(true);
                                                sendChat();
                                            }}
                                        >
                                            <FeatherIcon.Send className="icon-dual icon-md m-1" />
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </animated.div>
                    </div>
                </div>
                {/* {isModalOpen && (
                    <RaiseTicket
                        isModalOpen={isModalOpen}
                        updateModal={() => setIsModalOpen(!isModalOpen)}
                        setMessages={(result) => showDescription(result)}
                    />
                )} */}
            </div>
        </footer>
    );
};

export default Footer;
